import { KEYS, load, save } from './storage';

let ctx: AudioContext | null = null;
let muted = load<boolean>(KEYS.muted, false);
const listeners = new Set<() => void>();

export const isMuted = () => muted;
export function setMuted(value: boolean) {
  muted = value;
  save(KEYS.muted, value);
  listeners.forEach((l) => l());
}
export function subscribeMuted(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/** Must be called from a user gesture once so iOS allows audio. */
export function unlockAudio() {
  if (muted) return;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
  } catch {
    ctx = null;
  }
}

/** A short, quiet wooden "tick" for each wheel segment passing the pointer. */
export function tick() {
  if (muted || !ctx) return;
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'triangle';
  osc.frequency.setValueAtTime(1500, t);
  osc.frequency.exponentialRampToValueAtTime(600, t + 0.03);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.12, t + 0.004);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.05);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + 0.06);
}

/** A soft two-note chime (E6 → A6, like a doorbell) when another player joins the table. */
export function chime() {
  if (muted || !ctx) return;
  const t0 = ctx.currentTime;
  [
    { f: 1318.5, at: 0 },
    { f: 1760, at: 0.13 },
  ].forEach(({ f, at }) => {
    const t = t0 + at;
    const osc = ctx!.createOscillator();
    const gain = ctx!.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(f, t);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.16, t + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);
    osc.connect(gain).connect(ctx!.destination);
    osc.start(t);
    osc.stop(t + 0.6);
  });
}
